import { Routes, Route } from "react-router-dom";
import ClientLayout from "../layouts/ClientLayout";
import Home from "../client/pages/Home";
import AllProducts from "../client/pages/AllProducts";
import ProductDetail from "../client/pages/ProductDetail";
import Cart from "../client/pages/Cart";
import Contact from "../client/pages/Contact";
import ThankYou from "../client/pages/ThankYou";

import Checkout from "../client/pages/Checkout";
import Login from "../client/pages/Login";
import Register from "../client/pages/Register";
import NotAuthorized from "../shared/NotAuthorized";

// ✅ Log TOUS les composants
console.log("CHECK IMPORTS:", {
  ClientLayout,
  Home,
  Login,
  Register,
  AllProducts,
  ProductDetail,
  Cart,
  Checkout,
  ThankYou,
  NotAuthorized,
});
export default function ClientRoutes() {
  return (
    <Routes>
      <Route element={<ClientLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="thank-you" element={<ThankYou />} />

        <Route path="Contact" element={<Contact />} />
        <Route path="product/:id" element={<ProductDetail />} />
        <Route path="category/AllProducts" element={<AllProducts isAll={true} />} />

        <Route path="category/:categoryName" element={<AllProducts />} />

        <Route path="not-authorized" element={<NotAuthorized />} />
      </Route>
    </Routes>
  );
}